import React from "react";

const WizardProgressBar = ({ steps, currentStep }) => {
  return (
    <div className="d-flex justify-content-center align-items-center my-md-4 bg-white p-2 box-border-gr ml-2 mr-2">
      {steps.map((step, index) => {
        const isActive = step.id === currentStep;
        const isCompleted = step.id < currentStep;

        return (
          <div key={step.id} className="d-flex align-items-center flex-grow-1">
            <div className="text-center flex-grow-1">
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center 
                border font-weight-bold transition mx-auto
                ${isActive
                    ? "bg-success text-white border-success"
                    : isCompleted
                      ? "bg-success text-white border-success"
                      : "bg-light text-secondary border-secondary"
                  }`}
                style={{ width: "40px", height: "40px", minWidth: "32px", minHeight: "32px" }}
              >
                <span className="d-none d-sm-inline">{step.id}</span>
                <span className="d-sm-none text-xs">✓</span>
              </div>
              <div
                className={`small mt-1 mt-md-2 fnt-adj ${isActive ? "font-weight-bold text-dark" : "text-muted"}`}
                style={{ fontSize: "0.75rem" }}
              >
                {step.title}
              </div>
            </div>

            {index < steps.length - 1 && (
              <div
                className={`mx-1 mx-md-2 flex-grow-1`}
                style={{
                  minHeight: "2px",
                  height: "2px",
                  backgroundColor: isCompleted ? "#28a745" : "#ccc",
                }}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default WizardProgressBar;
